module.exports = __webpack_public_path__ + "img/gsndc2760_1.e422ac35.svg";